"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransactions = exports.getTransaction = exports.submitReimbursement = exports.submitRefund = exports.submitSale = void 0;
const shared_1 = require("@getgreenline/shared");
const enums_1 = require("../../../models/worldpay/transaction/enums");
const setBaseUrl = ({ tenantId, retailerId, offlinePaymentId }) => {
    return `${shared_1.WORLDPAY_API_URL}/worldpay/tenants/${tenantId}/retailers/${retailerId}/payments/${offlinePaymentId}`;
};
const submitSale = async (params) => {
    const { payload, ...restOfParams } = params;
    const apiUrl = `${setBaseUrl(restOfParams)}/${enums_1.TransactionTypes.SALE}`;
    const res = await shared_1.axios.post(apiUrl, payload);
    return res.data;
};
exports.submitSale = submitSale;
const submitRefund = async (params) => {
    const { payload, ...restOfParams } = params;
    const apiUrl = `${setBaseUrl(restOfParams)}/${enums_1.TransactionTypes.REFUND}`;
    const res = await shared_1.axios.post(apiUrl, payload);
    return res.data;
};
exports.submitRefund = submitRefund;
const submitReimbursement = async (params) => {
    const { payload, ...restOfParams } = params;
    const apiUrl = `${setBaseUrl(restOfParams)}/${enums_1.TransactionTypes.REIMBURSE}`;
    const res = await shared_1.axios.post(apiUrl, payload);
    return res.data;
};
exports.submitReimbursement = submitReimbursement;
const getTransaction = async (params) => {
    const { transactionId, ...restOfParams } = params;
    const apiUrl = `${setBaseUrl(restOfParams)}/transactions/${transactionId}`;
    const res = await shared_1.axios.get(apiUrl);
    const statusCode = res.status;
    return { statusCode, ...res.data };
};
exports.getTransaction = getTransaction;
const getTransactions = async (params) => {
    const apiUrl = `${setBaseUrl(params)}/transactions`;
    const res = await shared_1.axios.get(apiUrl);
    return res.data;
};
exports.getTransactions = getTransactions;
//# sourceMappingURL=WorldpayInternalTransactionAPI.js.map